<template>
	<nav v-if="$mq !== 'mobile'" class="grey-background" :class="checkoutHeaderStyle()">
		<div id="checkout-header" class="columns is-centered is-flex-mobile ">
			<div class="column is-vertical-center is-paddingless">
				<router-link :to="getRoute()" class="store-navigation-color">
					<BaseBackButton title="Back" :click="_navigateToHome" />
				</router-link>
			</div>
			<div class="column is-vertical-center">
				<router-link :to="getRoute()" exact class="navbar-item navbar-item--logo" :aria-label="`${getStoreName} home`">
					<img :alt="`${getStoreName} image`" @load="logoLoaded" class="navbar-item--logo" src="../../assets/store-logo.png">
				</router-link>
			</div>
			<div class="column">
			</div>
		</div>
	</nav>
	<nav v-else :class="{'has-text-centered': currentRoute.name === 'order-confirmation'}" class="navbar navbar--border navbar--height navbar--mobile" role="navigation" aria-label="main navigation">
		<ul class="navbar-list--inline">
			<div class="navbar-item">
				<div class="back-button-wrapper" v-if="displayBackButton()">
					<router-link :to="getRoute()" class="store-navigation-color">
						<BaseBackButton title="Back" />
					</router-link>
				</div>
			</div>
			<div class="navbar-item" v-if="showLogo">
				<router-link :to="getRoute()" class="logo-container" :class="{'checkout-header': currentRoute.name !== 'order-confirmation'}">
					<img :class="{'order-confirm-logo': currentRoute.name === 'order-confirmation'}" @load="logoLoaded" class="navbar-item--logo" src="../../assets/store-logo.png">
				</router-link>
			</div>
			<div class="navbar-item">
				<account-menu />
			</div>
		</ul>
	</nav>
</template>

<script>
import EventBus from '@EventBus';
import { mapGetters } from 'vuex';
import { APP_STORE } from '@/stores/defs';
import CurrentLocation from '@/components/header/CurrentLocation';
import AccountMenu from "@NavItem/AccountMenu.vue";
import layoutMixin from '@Mixin/layoutMixin';
import contactDetailsMixin from '@Mixin/contactDetailsMixin';
import navigationMixin from '@Mixin/navigationMixin';
import routeMixin from '@Mixin/routeMixin';

export default {
	mixins: [
		layoutMixin,
		contactDetailsMixin,
		navigationMixin,
		routeMixin,
	],
    components: {
		'current-location': CurrentLocation,
		'account-menu': AccountMenu,
    },
	data() {
		return {
			useMinimalVariant: false,
			isShowingLogo: true,
			isWideLogo: false,
		}
	},
    computed: {
        ...mapGetters({
            isDebug: APP_STORE.GET_DEBUG
        }),
        currentRoute() {
            return this.$route;
		},
		getStoreName() {
			const appConstants = this.$appConstants;
			const storeName = appConstants.storeName;
			return storeName;
		},
		showLogo() {
			const isOrderConfirmation = this._isOrderConfirmation;
			const show = this.isShowingLogo;
			return (show && !isOrderConfirmation);
		},
	},
    methods: {
        getRoute() {
            return {
                path: '/',
                ...(this.isDebug && {
                    query: {
                        debug: 1
                    }
                })
            };
		},
        displayBackButton() {
			// TODO move into route mixin
            const route = this.$route.name;
            if (route === 'home' || route === 'order-confirmation') {
                return false;
            }
            return true;
        },
		logoLoaded(data) {
			const container = this.$el;
			const image = data.currentTarget;
			const height = image.naturalHeight;
			const width = image.naturalWidth;
			const ratio = width/height;
			if (ratio > 1) {
				this.isWideLogo = true;
			}
		},
		minimalCheckoutActive() {
			const $appConstants = this.$appConstants;
			this.useMinimalVariant = $appConstants.checkout.minimal;
			const container = this.$el;
			container.classList.add('show-logo-minimal');
		},
		toggleContactForm() {
			EventBus.$emit('toggle-contact-form');
		},
		checkoutHeaderStyle() {
			return {
				'show-logo-minimal': this.useMinimalVariant,
				'show-wide-logo': this.isWideLogo,
			}
		},
	},
	mounted() {
		const checkoutLayout = this.getRouteLayout('Checkout');
		if (checkoutLayout === 'MinimalCheckout') {
			this.minimalCheckoutActive();
		}
	},
};
</script>

<style lang="scss">
@import 'globalStyles';
@import 'commonStyle/navbar';

#checkout-header {
    margin: 0em 3.5em 1em 3.5em;
    margin: auto;
    max-width: 1344px;
    height: $navigationBarHeight;

    .back-button-container {
		margin-left: 1em;
	}
	
	.navbar-item {
		// TODO use component here instead
		display: flex;
		justify-content: center;
		position: relative;
		top: 0;
		margin: 0 auto;
		img {
			max-width: 10em;
			max-height: 10em;
			width: auto;
		}
	}
}

.checkout-header-content {
    max-width: 1080px;
}

.justify-end {
    display: flex;
    align-items: right;
}
.flex-one {
    flex: 1;
}
.flex-two {
    flex: 2;
}

.is-vertical-center {
	justify-content: center;
}
.is-paddingless {
	justify-content: flex-start
}

.account-container {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;

	width: 100%;
	height: 100%;

	color: $storeButtonColor;
	.link {
		height: 0;
		font-size: 1.1em;
		font-weight: bold;
	}
}

@include desktop {
	.show-logo {
		#checkout-header {
			.navbar-item {
				position: relative;
				.logo-container {
					pointer-events: auto;
				}
			}
		}
	}
	#checkout-header {
		.navbar-item {
			position: relative;
			top: -1em;
			img {
				position: absolute;
				top: 0;
				max-width: 3em;
				max-height: 3em;
				&.show {
					position: relative;
				}
			}
		}
	}
	.show-wide-logo {
		#checkout-header {
			.navbar-item--logo {
				padding-top: 1em;
				max-width: 11em;
			}
		}
	}
}

@include mobile {
	.logo-container {
		pointer-events: none;
		&.checkout-header {
			display: flex;
			justify-content: center;
			position: relative;
			margin: auto;
			width: 100%;
			max-width: 23vw;
			height: $mobileNavigationHeight;
			text-align: center;
			img {
				// TODO it would probably make more sense if the franchisor uploaded
				// a horizontal and vertical image.
				// We do a ratio calculation to determine if the header is displayed
				opacity: 0;
				transition: .3s opacity;
				&.show {
					opacity: 1;
				}
			}
		}
	}
	.show-logo-minimal {
		.logo-container {
			&.checkout-header {
				max-width: unset;
				height: unset;
				img {
					opacity: 1;
					max-height: 9em;
					max-width: 7em;
				}
			}
		}
		&.navbar--mobile {
			border-bottom: none;
		}
	}
	#checkout-header {
		.navbar-item {
			position: absolute;
			img {
				position: absolute;
				top: 0;
			}
		}
	}
	.order-confirm-logo {
		// TODO use component here instead
		display: block;
        max-height: 1.5em;
        margin-top: 1em;
	}
}
</style>




// WEBPACK FOOTER //
// src/components/checkout/CheckoutHeader.vue